<app-layout>
  <dl class="row" *ngIf="lojistik">
    <dt class="col-5">Şube:</dt>
    <dd class="col-7">{{ lojistik.sube?.isim }}</dd>
    <dt class="col-5">Cari:</dt>
    <dd class="col-7">{{ lojistik.cari?.firmaUnvani }}</dd>
    <dt class="col-5">Fiyatlama Tarihi:</dt>
    <dd class="col-7">{{ lojistik.tarih | date: 'dd.MM.yyyy' }}</dd>
    <dt class="col-5">Mazot Baz Fiyatı:</dt>
    <dd class="col-7">{{ lojistik.mazotBazFiyati.toFixed(2) }} TL</dd>
    <dt class="col-5">Açıklama</dt>
    <dd class="col-7">{{ lojistik.aciklama }}</dd>
  </dl>

  <div class="row">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Rota Bilgileri</h3>
          <div class="card-options">
            <div class="text-muted">Arşiv
              <div class="dropdown">
                <app-loading-input *ngIf="!arsiv"></app-loading-input>
                <select *ngIf="arsiv" class="form-control" [(ngModel)]="arsiv.fiyat" (change)="degisimHesapla()">
                  <!-- <option [value]="null" disabled selected>Şeçiniz</option> -->
                  <option *ngFor="let p of arsiv" [ngValue]="p.fiyat">{{ p.fiyat.toFixed(2) }} TL -- {{ p.tarih | date: 'dd.MM.yyyy' }}
                  </option>
                </select>
                <!-- <button type="button" class="btn btn-white dropdown-toggle ml-3" data-toggle="dropdown">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-lg" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="12" cy="19" r="1"></circle>
                  <circle cx="12" cy="5" r="1"></circle>
                </svg>
                Filtrele
              </button> -->
                <!-- <div class="dropdown-menu dropdown-menu-right">
                <label class="dropdown-item" *ngFor="let f of filterStatus">
                  <input class="form-check-input m-0 mr-2" type="checkbox" [(ngModel)]="f.value"
                    (click)="filter(f.key)">
                  {{getDurumText(f.key)}}
                </label>
              </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table *ngIf="lojistik.rotalar?.length > 0" class="table card-table table-vcenter text-nowrap datatable">
            <thead>
              <tr>
                <th>#</th>
                <th>Başlangıç Noktası</th>
                <th>Varış Noktası</th>
                <th>Km</th>
                <th>Ürün Cinsi</th>
                <th>Araç Tipi</th>
                <th class="text-right">Fiyat</th>
                <th class="text-right">Değişen Fiyat</th>
                <th class="text-right">Net Değişim</th>
                <!-- <th></th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of lojistik.rotalar;let i=index;">
                <td>{{ i + 1 }}</td>
                <td>{{ r.baslangic?.aciklama }}</td>
                <td>{{ r.varis.aciklama }}</td>
                <td>{{ r.km }}</td>
                <td>{{ r.urunCinsi.aciklama }}</td>
                <td>{{ r.aracTipi.aciklama }}</td>
                <td class="text-right">{{ r.fiyat.toFixed(2) }} TL</td>
                <td class="text-right">{{ r.degisenFiyat.toFixed(2) }} TL</td>
                <td class="text-right">{{ r.netDegisim }} %</td>
                <!-- <td class="text-right">
                  <div class="btn btn-sm btn-danger" (click)="removeFromRequestList(i)">Kaldır</div>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</app-layout>